export const percentageOf = (value, target) => Math.round(100 / (target / value))

export const moneyFormat = value => value.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
